import axios from 'axios';
import storeInit from "../redux/stores"
import { removeUser } from '../redux/slices/authSlice';

const httpRequest = async (url, method = 'get', body = null, type="application/json", others) => {
    const token = storeInit.store.getState()?.auth?.user?.data?.authToken;
    try {
        const response = await axios({
            url,
            method,
            data: body,
            headers: {
                "Content-Type": type,
                Authorization: `Bearer ${token}`,
              },
            ...others,
            
        });
        return response?.data;
    } catch (error) {
        console.log(error)
        if(error.response?.status === 401){
            storeInit.store.dispatch(removeUser());
        }else{
            return error.response?.data;
        }
    }
};

export default httpRequest;